export const fetchingState = {
  FETCHING: 'fetching',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const simpleInputOperators = [ '=', '>', '<', '>=', '<=', 'like' ];
export const textOperators = [ '=', 'in', 'like' ];
export const defaultPageSize = 50;
export const savedSearchLimit = 10;

export const MAX_PRESENTATION_SLOTS = 7;

export const mapType = {
  GOOGLE: 'google',
  BING: 'bing',
  ARCGIS: 'arcgis'
};

export const MAX_RECORDS = 35;
export const TOP_RECORDS = 20;

export const CHART_TYPES = {
  LINE: 'line',
  COLUMN: 'column'
};

export const userTypes = {
  PRIVATE: 'private',
  INTERNAL: 'internal',
  PUBLIC: 'public'
};

export const credentials = {
  local: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      captchaKey: '6LfzdpoUAAAAAMqffBWG3vrOdtBhS05e5wuTfxSu',
      office: 'True Prodigy'
    }
  },
  dev: {
    urls: {
      api: 'https://dev-container.trueprodigyapi.com',
      captchaKey: '6LfzdpoUAAAAAMqffBWG3vrOdtBhS05e5wuTfxSu',
      office: 'True Prodigy'
    }
  },
  stage: {
    urls: {
      api: 'https://stage-container.trueprodigyapi.com',
      captchaKey: '6LfzdpoUAAAAAMqffBWG3vrOdtBhS05e5wuTfxSu',
      office: 'True Prodigy'
    }
  },
  prod: {
    urls: {
      api: 'https://prod-container.trueprodigyapi.com',
      captchaKey: '6LfzdpoUAAAAAMqffBWG3vrOdtBhS05e5wuTfxSu',
      office: 'Travis'
    }
  }
};
